
export class ArticleTour {
  id?: number;
  tourId?: number;
  name?: string;
}
